
import {GameModeTransitionControllerWithView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionControllerWithView";
import {GameModeTransitionView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionView";
import {ImmortalFruitsParsedGameData} from "../server/data/ImmortalFruitsParsedGameData";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ImmortalFruitsGameMode} from "../ImmortalFruitsGameMode";

export class BonusWheelIntroTransitionControllerWithView extends GameModeTransitionControllerWithView {
    /**
     * @constructs
     * @param fromMode
     * @param toMode
     */
    constructor(fromMode: string, toMode: string,view:GameModeTransitionView) {
        super(fromMode, toMode,view);
    }

    /**
     * @inheritDoc
     */
    protected addEventListeners(): void {
        super.addEventListeners();

    }
    /**
     * @inheritDoc
     * @param data
     */
    protected onGameDataParsed(data: ImmortalFruitsParsedGameData): void {
        super.onGameDataParsed(data);
    }

    /**
     * @inheritDoc
     */
    protected finish(): void {
        super.finish();
    }

    protected calculateIsTriggeredThisSpin(data:ParsedServerData):boolean{
        return (data.mode===ImmortalFruitsGameMode.GAMBLE||data.mode===ImmortalFruitsGameMode.NORMAL) && data.nextMode === ImmortalFruitsGameMode.BONUS_WHEEL;
    }
}